import { useState, useEffect } from 'react';
import { C } from '../../lib/tokens.js';
import { t } from '../../lib/data.js';
import { apiFetch } from '../../lib/api.js';

export function SideMenu({ active, onSelect, role, counts, me, extraGroups = [], children, isMobile = false, open = false, onClose }) {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    apiFetch('/version')
      .then(data => setVersion(data.version))
      .catch(() => {});
  }, []);

  const businessItems = [
    me?.canViewOrders   ? { id: 'orders',   icon: 'shopping_cart', label: t('nav.orders') }   : null,
    me?.canViewInvoices ? { id: 'invoices', icon: 'receipt_long',  label: t('nav.invoices') } : null,
    me?.canViewPayments ? { id: 'payments', icon: 'payments',      label: t('nav.payments') } : null,
  ].filter(Boolean);

  const groups = [
    {
      section: t('nav.helpdesk'),
      items: role === 'agent'
        ? [
            { id: 'requests', icon: 'support_agent',        label: t('nav.requests'), badge: counts.openRequests },
            { id: 'create',   icon: 'add_circle',           label: t('nav.new_request') },
          ]
        : [
            { id: 'requests', icon: 'support_agent', label: t('nav.requests'), badge: counts.openRequests },
            { id: 'create',   icon: 'add_circle',    label: t('nav.new_request') },
          ],
    },
    ...(me?.canViewSystemTimeline ? [{
      section: role === 'agent' ? t('nav.assets_agent') : t('nav.assets'),
      items: [{ id: 'assets', icon: 'dns', label: role === 'agent' ? t('nav.assets_agent') : t('nav.assets') }],
    }] : []),
    ...(businessItems.length > 0 ? [{ section: t('nav.business'), items: businessItems }] : []),
    ...extraGroups,
    {
      section: t('nav.account'),
      items: role === 'agent'
        ? [
            { id: 'about', icon: 'info_outline', label: t('nav.about') },
          ]
        : [
            { id: 'account', icon: 'person',       label: 'My Account' },
            { id: 'about',   icon: 'info_outline', label: t('nav.about') },
          ],
    },
  ];
  const handleSelect = id => {
    onSelect(id);
    onClose?.();
  };

  return (
    <>
      {isMobile && open && (
        <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 199 }} />
      )}
      <nav style={isMobile ? {
        position: 'fixed', top: 0, left: 0, height: '100vh', width: 'min(224px, 80vw)', zIndex: 200,
        background: C.tin, borderRight: `1px solid ${C.mercury}`,
        overflowY: 'auto', padding: '12px 0', display: 'flex', flexDirection: 'column',
        transform: open ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 200ms ease', boxShadow: open ? '2px 0 12px rgba(0,0,0,0.2)' : 'none',
      } : {
        width: 224, background: C.tin, borderRight: `1px solid ${C.mercury}`,
        flex: 'none', overflowY: 'auto', padding: '12px 0',
        display: 'flex', flexDirection: 'column',
      }}>
      {groups.map(g => (
        <div key={g.section} style={{ marginBottom: 8 }}>
          <div style={{
            padding: '10px 16px 6px', fontSize: 10, textTransform: 'uppercase',
            letterSpacing: '0.08em', color: C.silver, fontWeight: 500,
          }}>{g.section}</div>
          {g.items.map(item => (
            <NavItem key={item.id} item={item} active={active === item.id} onClick={() => handleSelect(item.id)} />
          ))}
        </div>
      ))}
      {children}
      <div style={{ padding: 12, marginTop: 'auto' }}>
        <div style={{ padding: 12, background: C.platinum, borderRadius: 6, border: `1px solid ${C.mercury}` }}>
          <div style={{ fontSize: 11, color: C.iron, display: 'flex', alignItems: 'center', gap: 4 }}>
            <span className="material-icons" style={{ fontSize: 14, color: C.patina }}>circle</span>
            All systems operational
          </div>
        </div>
        {version ? (
          <div style={{ fontSize: 10, color: C.silver, padding: '6px 4px 0' }}>AFSP v{version}</div>
        ) : null}
      </div>
    </nav>
    </>
  );
}

function NavItem({ item, active, onClick }) {
  const [hover, setHover] = useState(false);
  const bg = active ? '#F0F8FD' : hover ? C.chrome : 'transparent';
  return (
    <a onClick={onClick}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10, padding: '8px 16px',
        paddingLeft: active ? 14 : 16, fontSize: 13,
        color: active ? C.deepsea : C.iron, fontWeight: active ? 500 : 400,
        background: bg, borderLeft: active ? `2px solid ${C.liquid}` : '2px solid transparent',
        textDecoration: 'none', cursor: 'pointer', transition: 'background 120ms',
      }}>
      <span className="material-icons" style={{ fontSize: 18, color: active ? C.liquid : C.iron }}>{item.icon}</span>
      <span style={{ flex: 1 }}>{item.label}</span>
      {item.badge ? (
        <span style={{
          background: active ? C.liquid : C.silver, color: '#fff', borderRadius: 999,
          padding: '1px 7px', fontSize: 10, fontWeight: 500, minWidth: 18, textAlign: 'center',
        }}>{item.badge}</span>
      ) : null}
    </a>
  );
}
